import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import {
  EntitySearchModalComponent, EntitySearchData, EntitySearchResult
} from '../modals/entity-search-modal/entity-search-modal.component';

@Injectable({
  providedIn: 'root'
})
export class EntityModalsService {

  constructor(
    private modal: MatDialog
  ) { }

  searchEntity(options?: EntitySearchData): MatDialogRef<EntitySearchModalComponent, EntitySearchResult> {
    return this.modal.open<EntitySearchModalComponent, EntitySearchData, EntitySearchResult>(EntitySearchModalComponent, {
      width: '800px',
      height: '600px',
      maxWidth: '95%',
      maxHeight: '95%',
      hasBackdrop: true,
      disableClose: true,
      data: options
    });

  }

  getEntity(options?: EntitySearchData): Promise<EntitySearchResult> {
    return new Promise((resolve, reject) => {
      const ref = this.modal.open<EntitySearchModalComponent, EntitySearchData, EntitySearchResult>(EntitySearchModalComponent, {
        width: '800px',
        height: '600px',
        maxWidth: '95%',
        maxHeight: '95%',
        hasBackdrop: true,
        disableClose: true,
        data: options
      });

      ref.afterClosed().subscribe(data => {
        resolve(data);
      });

    });

  }
}
